import {Map,  List, fromJS} from 'immutable';
import  _ from 'lodash'


let tmp
function reducer(
        state=Map({
            items: Map(),
            categories: List(),
            current: null,
            currentPayload: null
        }),action) {
    switch (action.type) {
        case 'faq set current item':
            return state.set('current', action.payload.id)
        case 'faq set current payload':
            return state.set('currentPayload', action.payload)
        // ========= READ ===========
        case "FAQ_READ_BY_CATEGORY_SUCCESS":
        case "FAQS_UPDATE_SUCCESS":
            tmp = fromJS(_.keyBy(action.payload.faqs, (o)=>{
                return o.id
            }))
            return state.mergeDeepIn(['items'], tmp)

        case "FAQ_READ_SUCCESS":
            tmp = fromJS(_.keyBy(action.payload, (o)=>{
                return o.id
            }))
        return state.mergeDeepIn(['items'], tmp)

        case "FAQ_CREATE_SUCCESS":
        case "FAQ_UPDATE_SUCCESS":
            tmp = fromJS({[action.payload.faq.id]:action.payload.faq})
            return state.mergeDeepIn(['items'], tmp)
        case "FAQ_REMOVE_SUCCESS":
            return state.deleteIn(['items', String(action.payload.faq.id)])

        // small payload is ok to do this
        case "CATEGORIES_GET_SUCCESS":
        case "CATEGORY_CREATE_SUCCESS":
        case "CATEGORY_REMOVE_SUCCESS":
        case "CATEGORY_UPDATE_SUCCESS":
        case "CATEGORIES_UPDATE_SUCCESS":
            return state.set('categories', fromJS(action.payload))

        default:
            return state

      }
}


export default reducer



// WEBPACK FOOTER //
// ./src/model/FAQ/reducer.js